import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { useAuth } from '../../hooks/useAuth'; // Get user data from a clean hook

const RoleBasedWelcome = () => {
  const { user, role } = useAuth(); // Get user and role directly

  // Don't render anything if the user data isn't available yet
  if (!user) {
    return null;
  }

  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1"
        sx={{ fontWeight: 'bold' }}
      >
        Welcome back, {user.username || 'User'}!
      </Typography>

      <Box display="flex" alignItems="center" gap={1} mt={1}>
        <Typography color="text.secondary">
          Here's your overview for today.
        </Typography>
        <Chip 
          label={role} 
          color="primary" 
          size="small" 
          variant="outlined" 
        />
      </Box>
    </Box>
  );
};

export default RoleBasedWelcome;

// import React from 'react';
// import { 
//   Card, 
//   CardContent, 
//   Typography, 
//   Grid, 
//   Button, 
//   Box,
//   Chip,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useNavigation } from '../../hooks/useNavigation';

// const RoleBasedWelcome = () => {
//   const navigate = useNavigate();
//   const { 
//     roleInfo, 
//     user, 
//     quickAccessItems, 
//     navigationStats,
//     canAccess 
//   } = useNavigation();

//   if (!roleInfo) return null;

//   return (
//     <Grid container spacing={3}>
//       <Grid item xs={12} md={8}>
//         <Card>
//           <CardContent>
//             <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//               <Typography variant="h4" component="h1">
//                 Welcome back, {user?.username || user?.name}!
//               </Typography>
//               <Chip
//                 label={roleInfo.label || roleInfo.welcome}
//                 color={roleInfo.color}
//                 sx={{ ml: 2 }}
//               />
//             </Box>
            
//             <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
//               {roleInfo.welcome} - You have access to {navigationStats.totalItems} sections
//             </Typography>

//             <Typography variant="h6" gutterBottom>
//               Your Features:
//             </Typography>
//             <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 3 }}>
//               {roleInfo.features?.map((feature) => (
//                 <Chip
//                   key={feature}
//                   label={feature}
//                   variant="outlined"
//                   size="small"
//                 />
//               ))}
//             </Box>

//             <Typography variant="h6" gutterBottom>
//               Quick Actions:
//             </Typography>
//             <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//               {roleInfo.primaryActions?.map((action) => (
//                 <Button
//                   key={action}
//                   variant="outlined"
//                   size="small"
//                 >
//                   {action}
//                 </Button>
//               ))}
//             </Box>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12} md={4}>
//         <Card>
//           <CardContent>
//             <Typography variant="h6" gutterBottom>
//               Quick Access
//             </Typography>
//             <List dense>
//               {quickAccessItems.slice(0, 5).map((item) => {
//                 const Icon = item.icon;
//                 const hasAccess = canAccess(item.path);
                
//                 return (
//                   <ListItem
//                     key={item.id}
//                     button
//                     disabled={!hasAccess}
//                     onClick={() => hasAccess && navigate(item.path)}
//                     sx={{ 
//                       borderRadius: 1,
//                       mb: 0.5,
//                       opacity: hasAccess ? 1 : 0.5,
//                     }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 36 }}>
//                       <Icon fontSize="small" />
//                     </ListItemIcon>
//                     <ListItemText 
//                       primary={item.label}
//                       primaryTypographyProps={{ fontSize: '0.9rem' }}
//                     />
//                   </ListItem>
//                 );
//               })}
//             </List>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card>
//           <CardContent>
//             <Typography variant="h6" gutterBottom>
//               Access Summary
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={6} sm={3}>
//                 <Box textAlign="center">
//                   <Typography variant="h4" color="primary">
//                     {navigationStats.totalItems}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Total Sections
//                   </Typography>
//                 </Box>
//               </Grid>
//               <Grid item xs={6} sm={3}>
//                 <Box textAlign="center">
//                   <Typography variant="h4" color="secondary">
//                     {navigationStats.categoryCounts?.business || 0}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Business Tools
//                   </Typography>
//                 </Box>
//               </Grid>
//               <Grid item xs={6} sm={3}>
//                 <Box textAlign="center">
//                   <Typography variant="h4" color="info.main">
//                     {navigationStats.categoryCounts?.finance || 0}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Finance Tools
//                   </Typography>
//                 </Box>
//               </Grid>
//               <Grid item xs={6} sm={3}>
//                 <Box textAlign="center">
//                   <Typography variant="h4" color="warning.main">
//                     {navigationStats.categoryCounts?.admin || 0}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Admin Tools
//                   </Typography>
//                 </Box>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );
// };

// export default RoleBasedWelcome;